import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, of, switchMap } from 'rxjs';
import * as plantActions from '../actions/plant.actions';
import { PlantService } from '../../services/plant.service';

@Injectable()
export class PlantEffects {
  constructor(
    private actions$: Actions,
    private plantService: PlantService,
  ) {}

  loadPlants$ = createEffect(() =>
    this.actions$.pipe(
      ofType(plantActions.loadPlants),
      switchMap(() =>
        this.plantService.GetAllWithHierarchy().pipe(
          map((plants) => plantActions.loadPlantsSuccess({ plants })),
          catchError((error) => of(plantActions.loadPlantsFailure({ error }))),
        ),
      ),
    ),
  );
}
